var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91666 15.25C5.5945 15.5722 5.07216 15.5722 4.75 15.25C4.42783 14.9279 4.42783 14.4055 4.75 14.0834L8.83333 10L4.75 5.91669C4.42783 5.59452 4.42783 5.07219 4.75 4.75002C5.07216 4.42785 5.5945 4.42785 5.91666 4.75002L10 8.83335L14.0833 4.75002C14.4055 4.42785 14.9278 4.42785 15.25 4.75002C15.5722 5.07219 15.5722 5.59452 15.25 5.91669L11.1667 10L15.25 14.0834C15.5722 14.4055 15.5722 14.9279 15.25 15.25C14.9278 15.5722 14.4055 15.5722 14.0833 15.25L10 11.1667L5.91666 15.25Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.51027a51cccd78c451650d6f7e71f501.svg";
export { ForwardRef as ReactComponent };